<script>
	import { onMount } from 'svelte';
	import { registerSubmit } from "../../tealium";
	import model from '../../stores/modelStore';
	import { projectSettings } from '../../config';
	import { navigate } from "svelte-navigator";
	import PageSection from '../../components/PageSection.svelte';
	import Form from '../../components/Form.svelte';
	import FormRow from '../../components/FormRow.svelte';
	import FormColumn from '../../components/FormColumn.svelte';
	import SecondaryButton from '../../components/buttons/SecondaryButton.svelte';
	import NavigationButtons from '../../components/NavigationButtons.svelte';
	import ClassActionPhoneNumber from '../../components/ClassActionPhoneNumber.svelte';
	import ClassActionEmailAddress from '../../components/ClassActionEmailAddress.svelte';

	export let pageTitle = null;

	let buttons;

	document.title = pageTitle;

	window.onbeforeunload = null;
	const newRegistration = (e) => {
	console.log("NewRegistration clicked");
	}

	const handleSubmit = ()=> {
	buttons.blockNext();
	buttons.next();
	buttons.unblock();
	}

	$model.surveyComplete = false;
	onMount(() => registerSubmit($model.contact.emailAddress,
	$model.contact.phoneNumber,
	$model.registrationNumber)
	);
</script>

<PageSection>

    <FormRow class="justify-content-center">
        <FormColumn>
            <h1 class="text-center">{@html projectSettings.classActionName}</h1>
            <h2 class="text-center">Thank you for completing your registration form for the {@html projectSettings.classActionName}.</h2>
        </FormColumn>
    </FormRow>


    <FormRow>
        <FormColumn>
            <h3>Your reference number</h3>
            <div class="box">{$model.registrationNumber}</div>
    

            <p>
                If you have any questions, please contact Shine Lawyers on
                <ClassActionPhoneNumber></ClassActionPhoneNumber>, 
                or at <ClassActionEmailAddress></ClassActionEmailAddress> and quote the registration number above.
            </p>
        </FormColumn>
    </FormRow>

    <Form id="form-newReg-details" on:submit={handleSubmit}>
        <FormRow>
            <FormColumn>
                <h3>Add another claim</h3>
                <FormRow>
			        <FormColumn>
				        <NavigationButtons bind:buttons
					        nextPageLabel="I would like to complete another registration form to add another claim" 
                            disablePrevious={true}
                            showPrevious={false}
                            />
			        </FormColumn>
		        </FormRow>
     
            </FormColumn>
        </FormRow>
    </Form>

    

    <section class="whats-next full-width-wrapper">
        <FormRow class="justify-content-center">
            <FormColumn>
                <h2 class="text-center">What happens next</h2>
                <ul>
                    <li>We will be in touch by email or phone to update you as the settlement process progresses, or if further action is required.</li>
                    <li>
                        Check the 
                        <a href="{projectSettings.serviceUrl}" target="_blank" title="{projectSettings.classActionName} page">
                            {@html projectSettings.classActionName}
                        </a>
                        page for regular updates
                    </li>
                </ul>
            </FormColumn>
        </FormRow>
    </section>


</PageSection>

<style>

    .box {
        background-color: var(--color-white);
        border: solid 1px var(--color-border);
        border-radius: 1px;
        padding: var(--spacing-sm);
        transition: var(--transition-fast);
        height: 50px;
        font-size: 18px;
        line-height: 26px;
        color: var(--color-body);
    }
        
    .full-width-wrapper {
        box-shadow: 0 0 0 100vmax #fff;
        clip-path: inset(0 -100vmax);
    }

    .whats-next {
        background-color: var(--color-white);
        margin: 30px -30px;
        padding: 20px 30px;
    }

    .whats-next h2 {
        margin-bottom: 26px;
    }

    li {
        display: list-item;
        list-style-image: url("data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"%3E%3Cpath fill=\"none\" stroke=\"red\" stroke-width=\"2\" d=\"M3 7.5L6 10.5L11 4.5\"%3E%3C/path%3E%3C/svg%3E")
    }
</style>